// Error notice handling and display

// Requires .shorten class on container and corresponding show hide content classes

export function initLineWrapDetector() {
    const container = document.getElementById('link-list');

    // Abort if no container on page
    if (!container) return;

    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        // IMPORTANT: Temporarily remove 'shorten' class to see if the long text *could* fit - avoids on/off layout thrashing after shortening
        container.classList.remove('shorten');

        // Measure a single line height (with fallback height)
        const computedStyle = window.getComputedStyle(container);
        const lineHeight = parseFloat(computedStyle.lineHeight) || 24; // fallback

        // Check total content height is larger than one line
        // with added 5px buffer to prevent subpixel rounding glitches
        if (container.scrollHeight > lineHeight + 5) {
          // It wrapped! Add the shorten class
          container.classList.add('shorten');
        }
      }
    });

    // Start watching the container
    observer.observe(container);
}
